import axios from 'axios'
import decode from 'jwt-decode'
import { authApiClient } from '../httpClient'

export async function authenticate(code: string): Promise<any> {
    return await authApiClient.post(`/oauth/token?code=${code}`)
}

export async function logout(): Promise<any> {
    clearStorage()
}

export async function login(): Promise<any> {
    return await authApiClient.get(`/oauth/login`)
}

const isLoggedIn = () => {
    const accessToken = getAccessToken()
    const profile = getUserProfile()
    return accessToken && profile && !isTokenExpired(accessToken as string)
}

const setAccessToken = (accessToken: string) => {
    localStorage.setItem('access_token', accessToken)
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
}

const setIdToken = (idToken: string) => {
    localStorage.setItem('id_token', idToken)
}

const getAccessToken = () => {
    return localStorage.getItem('access_token')
}

const parseIdToken = () => {
    const idToken = localStorage.getItem('id_token')
    return idToken ? decode(idToken) : undefined
}
const setUserProfile = (user: any) => {
    delete user.cachedDentalForm // Temporary until we move dental form somewhere else
    localStorage.setItem('user_profile', JSON.stringify(user))
}

const getUserProfile = () => {
    const profile = localStorage.getItem('user_profile')
    return profile && profile !== 'undefined' ? JSON.parse(profile) : null
}

const isTokenExpired = (accessToken: string) => {
    if (!accessToken) return true
    const decodedToken: any = decode(accessToken)
    if (!decodedToken.exp) {
        return null
    }
    const date = new Date(0)
    date.setUTCSeconds(decodedToken.exp)
    return date < new Date()
}

const clearStorage = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('user_profile')
    axios.defaults.headers.common['Authorization'] = ''
}

export {
    setIdToken,
    getAccessToken,
    setAccessToken,
    isLoggedIn,
    clearStorage,
    getUserProfile,
    setUserProfile,
    parseIdToken,
}
